// Dados de exemplo no formato de GET /rpg/crews (docs/api-publica-rpg.md da API).
// O Provider usa estes dados quando a API nao responde.
module.exports = {
  crewsList: [
    {
      posicao: 1,
      slug: "void-alpha",
      nome: "Void Alpha",
      descricao: "A primeira frota do Void: caçadores de Reis do Mar e duelistas que não fogem de briga.",
      imagem: "/web-app-manifest-512x512.png",
      capacidade: 30,
      lider: { discordId: "300000000000000002", nome: "luffy_mugen" },
      xpTotal: 110630,
      vitoriasPvp: 40,
      membros: [
        {
          discordId: "300000000000000002",
          slug: "luffy_mugen",
          nome: "luffy_mugen",
          avatar: "https://cdn.discordapp.com/embed/avatars/2.png",
          nivel: 29,
          xp: 57950,
          patente: { key: "YONKOU", nome: "Yonkou", cor: "#facc15", icone: "👑", imagem: "" },
          lider: true,
        },
        {
          discordId: "300000000000000001",
          slug: "zoro_void",
          nome: "zoro_void",
          avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
          nivel: 26,
          xp: 41330,
          patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
          lider: false,
        },
        {
          discordId: "300000000000000010",
          slug: "jinbe_mar",
          nome: "jinbe_mar",
          avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
          nivel: 15,
          xp: 11350,
          patente: null,
          lider: false,
        },
      ],
    },
    {
      posicao: 2,
      slug: "void-beta",
      nome: "Void Beta",
      descricao: "Especialistas em raids e dungeons. Quem entra aqui sai com a fruta despertada.",
      imagem: "/web-app-manifest-192x192.png",
      capacidade: 30,
      lider: { discordId: "300000000000000004", nome: "sanji_blackleg" },
      xpTotal: 90090,
      vitoriasPvp: 15,
      membros: [
        {
          discordId: "300000000000000004",
          slug: "sanji_blackleg",
          nome: "sanji_blackleg",
          avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
          nivel: 23,
          xp: 32090,
          patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
          lider: true,
        },
        {
          discordId: "300000000000000012",
          slug: "yamato_oni",
          nome: "yamato_oni",
          avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
          nivel: 23,
          xp: 30650,
          patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
          lider: false,
        },
        {
          discordId: "300000000000000005",
          slug: "robin_ohara",
          nome: "robin_ohara",
          avatar: "https://cdn.discordapp.com/embed/avatars/5.png",
          nivel: 22,
          xp: 27350,
          patente: { key: "SUPERNOVA", nome: "Supernova", cor: "#f97316", icone: "⭐", imagem: "" },
          lider: false,
        },
      ],
    },
    {
      posicao: 3,
      slug: "void-gamma",
      nome: "Void Gamma",
      descricao: "A frota mais nova do Void, focada em chefes e em ensinar quem está começando.",
      imagem: "/favicon-96x96.png",
      capacidade: 25,
      lider: { discordId: "300000000000000007", nome: "chopper_doc" },
      xpTotal: 30860,
      vitoriasPvp: 3,
      membros: [
        {
          discordId: "300000000000000009",
          slug: "brook_soul",
          nome: "brook_soul",
          avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
          nivel: 18,
          xp: 15800,
          patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
          lider: false,
        },
        {
          discordId: "300000000000000007",
          slug: "chopper_doc",
          nome: "chopper_doc",
          avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
          nivel: 17,
          xp: 15060,
          patente: { key: "ROOKIE", nome: "Rookie", cor: "#7f00ff", icone: "🔰", imagem: "" },
          lider: true,
        },
      ],
    },
  ],
};
